/**
 * BayEngageReviews.Placeholders.Config
 *
 * Store-specific DOM anchors and the widget placeholders that should be inserted
 * relative to them.
 *
 * This is the only file that should contain theme class names. When the
 * extension is reused on another store, copy this file and change the selectors
 * to match that store's theme. The insertion logic in BayEngageReviews.Placeholders.js
 * reads these values and does not hard-code theme selectors.
 */

define('BayEngageReviews.Placeholders.Config', [], function () {
    'use strict';

    return [
        {
            area: 'pdp_stat',
            pages: ['pdp'],
            selector: '.product-details-full .product-details-full-content-header-title',
            position: 'after',
            placeholder: {
                id: '_tbr_stat',
                attrs: {
                    'data-rating-value': '0',
                    'data-review-count': '0'
                }
            }
        },
        {
            area: 'pdp_main',
            pages: ['pdp'],
            selector: '.product-detail',
            position: 'append',
            placeholders: [
                { id: '_tbr_pdr' },
                { id: '_tbr_qna' }
            ]
        },
        {
            area: 'home_widgets',
            pages: ['home'],
            selector: '.home-page',
            position: 'append',
            placeholders: [
                { id: '_tbr_endrsmtc', className: 'widget-container' },
                { id: '_tbr_sptltc' },
                { id: '_tbr_rev-sum' },
                { id: '_tbr_scrol' },
                { id: '_tbr_fomop', className: 'widget-container' }
            ]
        },
        {
            area: 'global_widgets',
            pages: ['all'],
            selector: '.footer-wrapper',
            fallbackSelectors: ['#site-footer', 'footer', 'body'],
            position: 'append',
            placeholder: {
                id: '_tbr_bus'
            }
        },
        {
            area: 'footer_badge',
            pages: ['all'],
            selector: '.footer-wrapper',
            position: 'append',
            placeholder: {
                id: '_tbr_bdg',
                style: 'text-align:center; margin-top:15px;'
            }
        },
        {
            area: 'newsletter_embed',
            pages: ['all'],
            selector: '.newsletter-subscription-form-container',
            position: 'replace',
            placeholder: {
                className: 'bayengage-embed-form',
                attrs: {
                    'data-id': '53141a97cabf'
                }
            }
        },
        {
            area: 'pdp_related_items',
            pages: ['pdp'],
            selector: '.item-relations-cell:not(.bx-clone) .item-relations-related-item-price',
            position: 'after',
            multiple: true,
            itemSelector: '.item-relations-cell',
            placeholder: {
                id: '_tbr_col_stat',
                attrs: {
                    'data-rating': '0',
                    'data-rating-value': '0',
                    'data-review-count': '0'
                }
            }
        },
        {
            area: 'plp_grid_stat',
            pages: ['plp'],
            selector: '.shopping-layout .facets-item-cell-grid-title',
            position: 'after',
            multiple: true,
            itemSelector: '.facets-item-cell-grid',
            placeholder: {
                id: '_tbr_col_stat',
                attrs: {
                    'data-rating': '0',
                    'data-rating-value': '0',
                    'data-review-count': '0'
                }
            }
        }
    ];
});
